const teams = [
    // NBA Teams
    { id: 'nba-1', name: 'Atlanta Hawks', sport: 'NBA', airport: 'ATL', venue: 'State Farm Arena' },
    { id: 'nba-2', name: 'Boston Celtics', sport: 'NBA', airport: 'BOS', venue: 'TD Garden' },
    { id: 'nba-3', name: 'Brooklyn Nets', sport: 'NBA', airport: 'NYC', venue: 'Barclays Center' },
    { id: 'nba-4', name: 'Charlotte Hornets', sport: 'NBA', airport: 'CLT' },
    { id: 'nba-5', name: 'Chicago Bulls', sport: 'NBA', airport: 'CHI' },
    { id: 'nba-6', name: 'Cleveland Cavaliers', sport: 'NBA', airport: 'CLE' },
    { id: 'nba-7', name: 'Dallas Mavericks', sport: 'NBA', airport: 'DFW' },
    { id: 'nba-8', name: 'Denver Nuggets', sport: 'NBA', airport: 'DEN' },
    { id: 'nba-9', name: 'Detroit Pistons', sport: 'NBA', airport: 'DTW' },
    { id: 'nba-10', name: 'Golden State Warriors', sport: 'NBA', airport: 'SFO' },
    { id: 'nba-11', name: 'Houston Rockets', sport: 'NBA', airport: 'IAH' },
    { id: 'nba-12', name: 'Indiana Pacers', sport: 'NBA', airport: 'IND' },
    { id: 'nba-13', name: 'Los Angeles Clippers', sport: 'NBA', airport: 'LAX' },
    { id: 'nba-14', name: 'Los Angeles Lakers', sport: 'NBA', airport: 'LAX' },
    { id: 'nba-15', name: 'Memphis Grizzlies', sport: 'NBA', airport: 'MEM' },
    { id: 'nba-16', name: 'Miami Heat', sport: 'NBA', airport: 'MIA' },
    { id: 'nba-17', name: 'Milwaukee Bucks', sport: 'NBA', airport: 'MKE' },
    { id: 'nba-18', name: 'Minnesota Timberwolves', sport: 'NBA', airport: 'MSP' },
    { id: 'nba-19', name: 'New Orleans Pelicans', sport: 'NBA', airport: 'MSY' },
    { id: 'nba-20', name: 'New York Knicks', sport: 'NBA', airport: 'NYC' },
    { id: 'nba-21', name: 'Oklahoma City Thunder', sport: 'NBA', airport: 'OKC' },
    { id: 'nba-22', name: 'Orlando Magic', sport: 'NBA', airport: 'MCO' },
    { id: 'nba-23', name: 'Philadelphia 76ers', sport: 'NBA', airport: 'PHL' },
    { id: 'nba-24', name: 'Phoenix Suns', sport: 'NBA', airport: 'PHX' },
    { id: 'nba-25', name: 'Portland Trail Blazers', sport: 'NBA', airport: 'PDX' },
    { id: 'nba-26', name: 'Sacramento Kings', sport: 'NBA', airport: 'SMF' },
    { id: 'nba-27', name: 'San Antonio Spurs', sport: 'NBA', airport: 'SAT' },
    { id: 'nba-28', name: 'Toronto Raptors', sport: 'NBA', airport: 'YYZ' },
    { id: 'nba-29', name: 'Utah Jazz', sport: 'NBA', airport: 'SLC' },
    { id: 'nba-30', name: 'Washington Wizards', sport: 'NBA', airport: 'WAS' },
  
    // MLB Teams
    { id: 'mlb-1', name: 'Arizona Diamondbacks', sport: 'MLB', airport: 'PHX' },
    { id: 'mlb-2', name: 'Atlanta Braves', sport: 'MLB', airport: 'ATL' },
    { id: 'mlb-3', name: 'Baltimore Orioles', sport: 'MLB', airport: 'BWI' },
    { id: 'mlb-4', name: 'Boston Red Sox', sport: 'MLB', airport: 'BOS' },
    { id: 'mlb-5', name: 'Chicago Cubs', sport: 'MLB', airport: 'MDW' },
    { id: 'mlb-6', name: 'Chicago White Sox', sport: 'MLB', airport: 'MDW' },
    { id: 'mlb-7', name: 'Cincinnati Reds', sport: 'MLB', airport: 'CVG' },
    { id: 'mlb-8', name: 'Cleveland Guardians', sport: 'MLB', airport: 'CLE' },
    { id: 'mlb-9', name: 'Colorado Rockies', sport: 'MLB', airport: 'DEN' },
    { id: 'mlb-10', name: 'Detroit Tigers', sport: 'MLB', airport: 'DTW' },
    { id: 'mlb-11', name: 'Houston Astros', sport: 'MLB', airport: 'HOU' },
    { id: 'mlb-12', name: 'Kansas City Royals', sport: 'MLB', airport: 'MCI' },
    { id: 'mlb-13', name: 'Los Angeles Angels', sport: 'MLB', airport: 'LAX' },
    { id: 'mlb-14', name: 'Los Angeles Dodgers', sport: 'MLB', airport: 'LAX' },
    { id: 'mlb-15', name: 'Miami Marlins', sport: 'MLB', airport: 'MIA' },
    { id: 'mlb-16', name: 'Milwaukee Brewers', sport: 'MLB', airport: 'MKE' },
    { id: 'mlb-17', name: 'Minnesota Twins', sport: 'MLB', airport: 'MSP' },
    { id: 'mlb-18', name: 'New York Mets', sport: 'MLB', airport: 'NYC' },
    { id: 'mlb-19', name: 'New York Yankees', sport: 'MLB', airport: 'NYC' },
    { id: 'mlb-20', name: 'Oakland Athletics', sport: 'MLB', airport: 'OAK' },
    { id: 'mlb-21', name: 'Philadelphia Phillies', sport: 'MLB', airport: 'PHL' },
    { id: 'mlb-22', name: 'Pittsburgh Pirates', sport: 'MLB', airport: 'PIT' },
    { id: 'mlb-23', name: 'San Diego Padres', sport: 'MLB', airport: 'SAN' },
    { id: 'mlb-24', name: 'San Francisco Giants', sport: 'MLB', airport: 'SFO' },
    { id: 'mlb-25', name: 'Seattle Mariners', sport: 'MLB', airport: 'SEA' },
    { id: 'mlb-26', name: 'St. Louis Cardinals', sport: 'MLB', airport: 'STL' },
    { id: 'mlb-27', name: 'Tampa Bay Rays', sport: 'MLB', airport: 'TPA' },
    { id: 'mlb-28', name: 'Texas Rangers', sport: 'MLB', airport: 'DFW' },
    { id: 'mlb-29', name: 'Toronto Blue Jays', sport: 'MLB', airport: 'YYZ' },
    { id: 'mlb-30', name: 'Washington Nationals', sport: 'MLB', airport: 'WAS' },
  
    // NFL Teams
    { id: 'nfl-1', name: 'Arizona Cardinals', sport: 'NFL', airport: 'PHX' },
    { id: 'nfl-2', name: 'Atlanta Falcons', sport: 'NFL', airport: 'ATL' },
    { id: 'nfl-3', name: 'Baltimore Ravens', sport: 'NFL', airport: 'BWI' },
    { id: 'nfl-4', name: 'Buffalo Bills', sport: 'NFL', airport: 'BUF' },
    { id: 'nfl-5', name: 'Carolina Panthers', sport: 'NFL', airport: 'CLT' },
    { id: 'nfl-6', name: 'Chicago Bears', sport: 'NFL', airport: 'MDW' },
    { id: 'nfl-7', name: 'Cincinnati Bengals', sport: 'NFL', airport: 'CVG' },
    { id: 'nfl-8', name: 'Cleveland Browns', sport: 'NFL', airport: 'CLE' },
    { id: 'nfl-9', name: 'Dallas Cowboys', sport: 'NFL', airport: 'DFW' },
    { id: 'nfl-10', name: 'Denver Broncos', sport: 'NFL', airport: 'DEN' },
    { id: 'nfl-11', name: 'Detroit Lions', sport: 'NFL', airport: 'DTW' },
    { id: 'nfl-12', name: 'Green Bay Packers', sport: 'NFL', airport: 'GNV' },
    { id: 'nfl-13', name: 'Houston Texans', sport: 'NFL', airport: 'HOU' },
    { id: 'nfl-14', name: 'Indianapolis Colts', sport: 'NFL', airport: 'IND' },
    { id: 'nfl-15', name: 'Jacksonville Jaguars', sport: 'NFL', airport: 'MIA' },
    { id: 'nfl-16', name: 'Kansas City Chiefs', sport: 'NFL', airport: 'MCI' },
    { id: 'nfl-17', name: 'Las Vegas Raiders', sport: 'NFL', airport: 'LAS' },
    { id: 'nfl-18', name: 'Los Angeles Chargers', sport: 'NFL', airport: 'LAX' },
    { id: 'nfl-19', name: 'Los Angeles Rams', sport: 'NFL', airport: 'LAX' },
    { id: 'nfl-20', name: 'Miami Dolphins', sport: 'NFL', airport: 'MIA' },
    { id: 'nfl-21', name: 'Minnesota Vikings', sport: 'NFL', airport: 'MSP' },
    { id: 'nfl-22', name: 'New England Patriots', sport: 'NFL', airport: 'BOS' },
    { id: 'nfl-23', name: 'New Orleans Saints', sport: 'NFL', airport: 'MSY' },
    { id: 'nfl-24', name: 'New York Giants', sport: 'NFL', airport: 'NYC' },
    { id: 'nfl-25', name: 'New York Jets', sport: 'NFL', airport: 'NYC' },
    { id: 'nfl-26', name: 'Philadelphia Eagles', sport: 'NFL', airport: 'PHL' },
    { id: 'nfl-27', name: 'Pittsburgh Steelers', sport: 'NFL', airport: 'PIT' },
    { id: 'nfl-28', name: 'San Francisco 49ers', sport: 'NFL', airport: 'SFO' },
    { id: 'nfl-29', name: 'Seattle Seahawks', sport: 'NFL', airport: 'SEA' },
    { id: 'nfl-30', name: 'Tampa Bay Buccaneers', sport: 'NFL', airport: 'TPA' },
    { id: 'nfl-31', name: 'Tennessee Titans', sport: 'NFL', airport: 'BNA' },
    { id: 'nfl-32', name: 'Washington Commanders', sport: 'NFL', airport: 'WAS' },
  
    // MLS Teams
    { id: 'mls-1', name: 'Atlanta United FC', sport: 'MLS', airport: 'ATL' },
    { id: 'mls-2', name: 'Austin FC', sport: 'MLS', airport: 'AUS' },
    { id: 'mls-3', name: 'Charlotte FC', sport: 'MLS', airport: 'CLT' },
    { id: 'mls-4', name: 'Chicago Fire FC', sport: 'MLS', airport: 'CHI' },
    { id: 'mls-5', name: 'Colorado Rapids', sport: 'MLS', airport: 'DEN' },
    { id: 'mls-6', name: 'Columbus Crew', sport: 'MLS', airport: 'CMH' },
    { id: 'mls-7', name: 'D.C. United', sport: 'MLS', airport: 'WAS' },
    { id: 'mls-8', name: 'FC Cincinnati', sport: 'MLS', airport: 'CVG' },
    { id: 'mls-9', name: 'FC Dallas', sport: 'MLS', airport: 'DFW' },
    { id: 'mls-10', name: 'Houston Dynamo FC', sport: 'MLS', airport: 'HOU' },
    { id: 'mls-11', name: 'Inter Miami CF', sport: 'MLS', airport: 'MIA' },
    { id: 'mls-12', name: 'LA Galaxy', sport: 'MLS', airport: 'LAX' },
    { id: 'mls-13', name: 'LAFC', sport: 'MLS', airport: 'LAX' },
    { id: 'mls-14', name: 'Minnesota United FC', sport: 'MLS', airport: 'MSP' },
    { id: 'mls-15', name: 'Montreal Impact', sport: 'MLS', airport: 'MTL' },
    { id: 'mls-16', name: 'Nashville SC', sport: 'MLS', airport: 'BNA' },
    { id: 'mls-17', name: 'New England Revolution', sport: 'MLS', airport: 'BOS' },
    { id: 'mls-18', name: 'New York City FC', sport: 'MLS', airport: 'NYC' },
    { id: 'mls-19', name: 'New York Red Bulls', sport: 'MLS', airport: 'NYC' },
    { id: 'mls-20', name: 'Orlando City SC', sport: 'MLS', airport: 'MCO' },
    { id: 'mls-21', name: 'Philadelphia Union', sport: 'MLS', airport: 'PHL' },
    { id: 'mls-22', name: 'Portland Timbers', sport: 'MLS', airport: 'PDX' },
    { id: 'mls-23', name: 'Real Salt Lake', sport: 'MLS', airport: 'SLC' },
    { id: 'mls-24', name: 'San Jose Earthquakes', sport: 'MLS', airport: 'SJC' },
    { id: 'mls-25', name: 'Seattle Sounders FC', sport: 'MLS', airport: 'SEA' },
    { id: 'mls-26', name: 'Sporting Kansas City', sport: 'MLS', airport: 'KCK' },
    { id: 'mls-27', name: 'St. Louis City SC', sport: 'MLS', airport: 'STL' },
    { id: 'mls-28', name: 'Toronto FC', sport: 'MLS', airport: 'YYZ' },
    { id: 'mls-29', name: 'Vancouver Whitecaps FC', sport: 'MLS', airport: 'YVR' },
    // NHL Teams
    { id: 'nhl-1', name: 'Anaheim Ducks', sport: 'NHL', airport: 'SNA' },
    { id: 'nhl-2', name: 'Arizona Coyotes', sport: 'NHL', airport: 'PHX' },
    { id: 'nhl-3', name: 'Boston Bruins', sport: 'NHL', airport: 'BOS' },
    { id: 'nhl-4', name: 'Buffalo Sabres', sport: 'NHL', airport: 'BUF' },
    { id: 'nhl-5', name: 'Calgary Flames', sport: 'NHL', airport: 'YVR' },
    { id: 'nhl-6', name: 'Carolina Hurricanes', sport: 'NHL', airport: 'RDU' },
    { id: 'nhl-7', name: 'Chicago Blackhawks', sport: 'NHL', airport: 'CHI' },
    { id: 'nhl-8', name: 'Colorado Avalanche', sport: 'NHL', airport: 'DEN' },
    { id: 'nhl-9', name: 'Columbus Blue Jackets', sport: 'NHL', airport: 'CMH' },
    { id: 'nhl-10', name: 'Dallas Stars', sport: 'NHL', airport: 'DAL' },
    { id: 'nhl-11', name: 'Detroit Red Wings', sport: 'NHL', airport: 'DTW' },
    { id: 'nhl-12', name: 'Edmonton Oilers', sport: 'NHL', airport: 'YEG' },
    { id: 'nhl-13', name: 'Florida Panthers', sport: 'NHL', airport: 'MIA' },
    { id: 'nhl-14', name: 'Los Angeles Kings', sport: 'NHL', airport: 'LAX' },
    { id: 'nhl-15', name: 'Minnesota Wild', sport: 'NHL', airport: 'MSP' },
    { id: 'nhl-16', name: 'Montreal Canadiens', sport: 'NHL', airport: 'MTL' },
    { id: 'nhl-17', name: 'Nashville Predators', sport: 'NHL', airport: 'BNA' },
    { id: 'nhl-18', name: 'New Jersey Devils', sport: 'NHL', airport: 'EWR' },
    { id: 'nhl-19', name: 'New York Islanders', sport: 'NHL', airport: 'EWR' },
    { id: 'nhl-20', name: 'New York Rangers', sport: 'NHL', airport: 'NYC' },
    { id: 'nhl-21', name: 'Ottawa Senators', sport: 'NHL', airport: 'YOW' },
    { id: 'nhl-22', name: 'Philadelphia Flyers', sport: 'NHL', airport: 'PHL' },
    { id: 'nhl-23', name: 'Pittsburgh Penguins', sport: 'NHL', airport: 'PIT' },
    { id: 'nhl-24', name: 'San Jose Sharks', sport: 'NHL', airport: 'SJC' },
    { id: 'nhl-25', name: 'Seattle Kraken', sport: 'NHL', airport: 'SEA' },
    { id: 'nhl-26', name: 'St. Louis Blues', sport: 'NHL', airport: 'STL' },
    { id: 'nhl-27', name: 'Tampa Bay Lightning', sport: 'NHL', airport: 'TPA' },
    { id: 'nhl-28', name: 'Toronto Maple Leafs', sport: 'NHL', airport: 'YYZ' },
    { id: 'nhl-29', name: 'Vancouver Canucks', sport: 'NHL', airport: 'YVR' },
    { id: 'nhl-30', name: 'Vegas Golden Knights', sport: 'NHL', airport: 'LAS' },
    { id: 'nhl-31', name: 'Washington Capitals', sport: 'NHL', airport: 'BWI' },
    { id: 'nhl-32', name: 'Winnipeg Jets', sport: 'NHL', airport: 'YWG' },
    // College Football (Top 25 + Notable Programs)
    { id: 'ncaaf-1', name: 'Alabama Crimson Tide', sport: 'NCAAF', airport: 'BHM' },
    { id: 'ncaaf-2', name: 'Georgia Bulldogs', sport: 'NCAAF', airport: 'ATL' },
    { id: 'ncaaf-3', name: 'Michigan Wolverines', sport: 'NCAAF', airport: 'DTW' },
    { id: 'ncaaf-4', name: 'Ohio State Buckeyes', sport: 'NCAAF', airport: 'CMH' },
    { id: 'ncaaf-5', name: 'Texas Longhorns', sport: 'NCAAF', airport: 'AUS' },
    { id: 'ncaaf-6', name: 'Florida State Seminoles', sport: 'NCAAF', airport: 'TLH' },
    { id: 'ncaaf-7', name: 'Penn State Nittany Lions', sport: 'NCAAF', airport: 'SCE' },
    { id: 'ncaaf-8', name: 'Washington Huskies', sport: 'NCAAF', airport: 'SEA' },
    { id: 'ncaaf-9', name: 'Oregon Ducks', sport: 'NCAAF', airport: 'EUG' },
    { id: 'ncaaf-10', name: 'LSU Tigers', sport: 'NCAAF', airport: 'BTR' },
    { id: 'ncaaf-11', name: 'Notre Dame Fighting Irish', sport: 'NCAAF', airport: 'SBN' },
    { id: 'ncaaf-12', name: 'Oklahoma Sooners', sport: 'NCAAF', airport: 'OKC' },
    { id: 'ncaaf-13', name: 'Tennessee Volunteers', sport: 'NCAAF', airport: 'TYS' },
    { id: 'ncaaf-14', name: 'Clemson Tigers', sport: 'NCAAF', airport: 'GSP' },
    { id: 'ncaaf-15', name: 'USC Trojans', sport: 'NCAAF', airport: 'LAX' },
    { id: 'ncaaf-16', name: 'Miami Hurricanes', sport: 'NCAAF', airport: 'MIA' },
    { id: 'ncaaf-17', name: 'Texas A&M Aggies', sport: 'NCAAF', airport: 'CLL' },
    { id: 'ncaaf-18', name: 'Wisconsin Badgers', sport: 'NCAAF', airport: 'MSN' },
    { id: 'ncaaf-19', name: 'Auburn Tigers', sport: 'NCAAF', airport: 'ATL' },
    { id: 'ncaaf-20', name: 'Florida Gators', sport: 'NCAAF', airport: 'GNV' },
    { id: 'ncaaf-21', name: 'Michigan State Spartans', sport: 'NCAAF', airport: 'LAN' },
    { id: 'ncaaf-22', name: 'UCLA Bruins', sport: 'NCAAF', airport: 'LAX' },
    { id: 'ncaaf-23', name: 'Iowa Hawkeyes', sport: 'NCAAF', airport: 'CID' },
    { id: 'ncaaf-24', name: 'Nebraska Cornhuskers', sport: 'NCAAF', airport: 'LNK' },
    { id: 'ncaaf-25', name: 'Oklahoma State Cowboys', sport: 'NCAAF', airport: 'SWO' }
  ];
  
  export default teams;